// <fr-sync id="..."> : bloque de la ficha que debe cambiar con la variante
// (ficha técnica, botón de WhatsApp). Dawn publica el HTML de la sección con la
// variante nueva en el evento variantChange; aquí solo se copia el bloque con el
// mismo id. No calcula nada: el contenido lo arma Liquid.
if (!customElements.get('fr-sync')) {
  customElements.define(
    'fr-sync',
    class FrSync extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !this.id) return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const nuevo = event?.data?.html?.getElementById?.(this.id);
          if (nuevo && nuevo.innerHTML !== this.innerHTML) this.innerHTML = nuevo.innerHTML;
        });
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }
    }
  );
}
